import { IFIReportType } from '@cims-online/shared'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { useProjectSettingsContext } from '../../../../ProjectSettingsContext'
import { useState } from 'react'
import EnabledIndicator from '../../components/EnabledIndicator'
import DirtyHeader from '../../components/DirtyHeader'
import PunchListEditPanel from './components/PunchListEditPanel'
import PunchListViewPanel from './components/PunchListViewPanel'
import Typography from 'antd/lib/typography/Typography'
import { Space } from 'antd'

const usePunchListPanel = (): CIMSCollapsePanelOptions => {
  const {
    punchListIFISettings: { data },
    canEdit,
  } = useProjectSettingsContext()
  const [isDirty, setIsDirty] = useState(false)

  return {
    header: {
      children: (
        <DirtyHeader
          title={IFIReportType.DailyInspectionPunchList.type}
          isDirty={isDirty}
        />
      ),
    },
    key: IFIReportType.DailyInspectionPunchList.id,
    extra: {
      children: <EnabledIndicator enabled={data?.enabled} />,
    },
    children: (
      <Space direction="vertical" size="middle">
        <Typography>
          All Punch Lists issue Identified Field Issues. The description is used
          to issue the Identified Field issue.
        </Typography>
        {canEdit ? (
          <PunchListEditPanel {...{ isDirty, setIsDirty }} />
        ) : (
          <PunchListViewPanel />
        )}
      </Space>
    ),
  }
}

export default usePunchListPanel
